import React from 'react';
import '../less/credits.less';
import { Link, Button, Control } from 'MWC';
import BusinessOrder from '../../BusinessOrder';
import TransfersToCard from '../transfersToCard';
import Calculator from '../../../auxiliary-components/Calculator';
import FilesForDownload from "../../../auxiliary-components/shared/FilesForDownload/views/file.c";

export default function () {
    const { lang } = this.props,
        isMobile = this.isViewportMobile(),
        model = this.getModel(),
        fullListOfTariffs = (
            <>
                <p className="tariff-name">{this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_1')}</p>
                <p className="tariff-description">{this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_1')}</p>
                <p className="tariff-name">{this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_2')}</p>
                <p className="tariff-description">{this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_2')}</p>
                <p className="tariff-name">{this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_3')}</p>
                <p className="tariff-description">{this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_3')}</p>
                <p className="tariff-name">{this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_4')}</p>
                <p className="tariff-description">{this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_4')}</p>
                <p className="tariff-name">{this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_5')}</p>
                <p className="tariff-description">{this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_5')}</p>
                <p className="tariff-name">{this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_6')}</p>
              <p className="tariff-description">{this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_6')}</p>
                <p className="tariff-name tariff-sub-name">{this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_6_1')}</p>
              <p className="tariff-description">{this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_6_1')}</p>
                <p className="tariff-name tariff-sub-name">{this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_6_2')}</p>
                <p className="tariff-description">{this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_6_2')}</p>
                <p className="tariff-name">{this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_7')}</p>
                <p className="tariff-description">{this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_7')}</p>
                <p className="tariff-name tariff-sub-name">{this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_7_1')}</p>
                <p className="tariff-description">{this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_7_1')}</p>
                <p className="tariff-name tariff-sub-name">{this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_7_2')}</p>
                <p className="tariff-description">{this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_7_2')}</p>
                <p className="tariff-name">{this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_8')}</p>
                <p className="tariff-description">{this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_8')}</p>
                <p
                    className="tariff-name"
                    dangerouslySetInnerHTML={{ __html: this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_9') }}
                />
                <p
                    className="tariff-description"
                    dangerouslySetInnerHTML={{ __html: this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_9') }}
                />
                <p
                    className="tariff-name tariff-sub-name"
                    dangerouslySetInnerHTML={{
                        __html: this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_9_1'),
                    }}
                />
                <p
                    className="tariff-description"
                    dangerouslySetInnerHTML={{
                        __html: this.l10n(
                            isMobile
                                ? 'BUSINESS_CREDITS_TARIFF_TEXT_9_1_MOB'
                                : 'BUSINESS_CREDITS_TARIFF_TEXT_9_1',
                        ),
                    }}
                />
                <p
                    className="tariff-name tariff-sub-name"
                    dangerouslySetInnerHTML={{
                        __html: this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_9_2'),
                    }}
                />
                <p
                    className="tariff-description"
                    dangerouslySetInnerHTML={{
                        __html: this.l10n(
                            isMobile
                                ? 'BUSINESS_CREDITS_TARIFF_TEXT_9_2_MOB'
                                : 'BUSINESS_CREDITS_TARIFF_TEXT_9_2',
                        ),
                    }}
                />
                <p className="tariff-name">{this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_10')}</p>
                <p className="tariff-description">{this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_10')}</p>
                <p className="tariff-name">{this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_12')}</p>
                <p className="tariff-description">{this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_12')}</p>
                <p className="tariff-name">{this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_13')}</p>
                <p className="tariff-description">{this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_13')}</p>
                <p className="tariff-name">{this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_14')}</p>
                <p className="tariff-description">{this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_14')}</p>
            </>
        ),
        shortListOfTariffs = (
            <>
                <p className="tariff-name">{this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_1')}</p>
                <p className="tariff-description">{this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_1')}</p>
                <p className="tariff-name">{this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_2')}</p>
                <p className="tariff-description">{this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_2')}</p>
                <p className="tariff-name">{this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_3')}</p>
                <p className="tariff-description">{this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_3')}</p>
                <p className="tariff-name">{this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_4')}</p>
                <p className="tariff-description">{this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_4')}</p>
                <p className="tariff-name">{this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_5')}</p>
                <p className="tariff-description">{this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_5')}</p>
                <p className="tariff-name">{this.l10n('BUSINESS_CREDITS_TARIFF_TITLE_6')}</p>
                <p className="tariff-description">{this.l10n('BUSINESS_CREDITS_TARIFF_TEXT_6')}</p>
            </>
        ),
        listToDisplay = !isMobile
            ? fullListOfTariffs
            : this.state.showFull
                ? fullListOfTariffs
                : shortListOfTariffs,
        toggler = isMobile ? (
            <button className="toggle-btn" onClick={this.toggleList}>
                {this.state.showFull
                    ? this.l10n('BUSINESS_CREDITS_HIDE')
                    : this.l10n('BUSINESS_CREDITS_SHOW_MORE')}
            </button>
        ) : null,
        modal = this.state.showModal ? (
            <BusinessOrder attribute="kredlim" closeModal={this.toggleModal}
                           calcData={{
                               commission: model.findAverageRepayment(),
                               rate: model.findAverageRatePayment(),
                               cost: model.findAverageSum()
                           }} />
        ) : (
                ''
            ),
        openCredLimFile = '/static/business/open_cred_lim.pdf',
        calc = !model.creditSum ? (
            ''
            ) : (
                <div className="credit-calculator">
                    <p className="credit-limit-title">{this.l10n('CREDIT_INSTALLMENT_CALC')}</p>
                    <div className="calculator-wrapper">
                        <Calculator model={this.getModel()} type="credit" {...this.props} toggleModal={this.toggleModal} />
                    </div>
                </div>
            );

    return (
        <>
            <div className="business-credit-page-container ">
                <div className="banner">
                    <div className="content">
                        <div className="banner-title">{this.l10n('BUSINESS_CREDITS_BANNER_TITLE')}</div>
                        <div className="banner-message">
                            {this.l10n('BUSINESS_CREDITS_BANNER_MESSAGE')}
                        </div>
                        <Button className="btn-success" onClick={this.toggleModal}>
                            {this.l10n('BUSINESS_GET_CONSULT')}
                        </Button>
                        <Link
                            href={`/business`}
                            onClick={e => this.context.app.navigate(`/business`, e)}
                        >
                            <div className="backward-btn">
                                {this.l10n('BUSINESS_BANNER_TO_BUSINESS')}
                            </div>
                        </Link>
                    </div>
                </div>
                <div className="content">
                    <div className="credit-limit-account">
                        <span className="credit-limit-title">
                            {this.l10n('BUSINESS_CREDITS_ACCOUNT')}
                        </span>
                        <ul className="credit-limit-list">
                            <ol
                                className="credit-limit-list-item"
                                dangerouslySetInnerHTML={{ __html: this.l10n('BUSINESS_CREDITS_ITEM_1') }}
                            />
                            <ol className="credit-limit-list-item">
                                {this.l10n('BUSINESS_CREDITS_ITEM_2')}
                            </ol>
                            <ol className="credit-limit-list-item">
                                {this.l10n('BUSINESS_CREDITS_ITEM_3')}
                            </ol>
                            <ol className="credit-limit-list-item">
                                {this.l10n('BUSINESS_CREDITS_ITEM_4')}
                            </ol>
                            <ol className="credit-limit-list-item">
                                {this.l10n('BUSINESS_CREDITS_ITEM_5')}
                            </ol>
                            <ol className="credit-limit-list-item">
                                {this.l10n('BUSINESS_CREDITS_ITEM_6')}
                            </ol>
                        </ul>
                        <div className="credit-limit-buttons">
                            <Button className="btn-success" onClick={this.toggleModal}>
                                {this.l10n('BUSINESS_GET_CONSULT')}
                            </Button>
                        </div>
                    </div>

                    <div className="credit-limit-block">
                        <span className="credit-limit-title">
                            {this.l10n('BUSINESS_CREDITS_WE_SET_LIMIT')}
                        </span>
                        <div className="credit-limit-description">
                            <div className="credit-limit-description-item margin-left">
                                <p className="description-title">
                                    {this.l10n('BUSINESS_CREDITS_UP_TO_100000')}
                                </p>
                                <p className="description-text">
                                    {this.l10n('BUSINESS_CREDITS_CREDIT_SUM')}
                                </p>
                            </div>
                            <div className="credit-limit-description-item">
                                <p className="description-title">
                                    {this.l10n('BUSINESS_CREDITS_UP_TO_30_DAYS')}
                                </p>
                                <p className="description-text">
                                    {this.l10n('BUSINESS_CREDITS_FREE_USAGE')}
                                </p>
                            </div>
                            <div className="credit-limit-description-item margin-left">
                                <p className="description-title">
                                    {this.l10n('BUSINESS_CREDITS_FREE')}
                                </p>
                                <p className="description-text">
                                    {this.l10n('BUSINESS_CREDITS_LIMIT_SETTING')}
                                </p>
                            </div>
                            <div className="credit-limit-description-item">
                                <p className="description-title">
                                    {this.l10n('BUSINESS_CREDITS_NO_BAIL')}
                                </p>
                                <p className="description-text">
                                    {this.l10n('BUSINESS_CREDITS_LIMIT_GET')}
                                </p>
                            </div>
                        </div>
                    </div>

                    {calc}

                    <div className={'transfer-to-card-wrapper'}>
                        <TransfersToCard {...this.props} callback={this.toggleModal} />
                    </div>

                    <div className="credit-limit-tariffs">
                        <span className="credit-limit-title">
                            {this.l10n('BUSINESS_CREDITS_TARIFF')}
                        </span>
                        <div className="tariff-items">{listToDisplay}</div>
                        {toggler ? <div className="credit-limit-tariffs-buttons">{toggler}</div> : ''}
                    </div>

                  <FilesForDownload page={"white-page"} lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, "files_to_download")}/>
                </div>
                {modal}
            </div>
        </>
    );
}
